// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u-fs-12 {
  font-size: 12px;
}

.c-checkbox {
  margin-top: 25px;
  margin-bottom: 20px;
}
.c-checkbox .c-checkbox--blue .c-checkbox__input:checked + .c-checkbox__icon::after {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIiBmaWxsPSIjMDI1RUExIi8+PHBhdGggZD0iTTggMTUuNzc1TDMgMTAuNzc1TDQuNzYyNSA5TDggMTIuMjM3NUwxNi4yMzc1IDRMMTggNS43NzUiIGZpbGw9IndoaXRlIi8+PC9zdmc+") !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent !important;
  border: none !important;
  top: 0 !important;
  left: 0 !important;
  width: 20px !important;
  height: 20px !important;
}
.c-checkbox .c-checkbox--blue .c-checkbox__label {
  color: #A2A8AE;
}
.c-checkbox .c-checkbox__icon::before {
  border: 1px solid var(--ids-theme-checkbox-border-color, #fff) !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
